<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <mask :id="maskId">
            <path fill="white" d="M16 0H0v16h16V0Z" />
            <path fill="black" d="M2 8a6 6 0 1 1 12 0H2Z" />
        </mask>

        <path fill="currentColor" d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z" :mask="`url(#${maskId})`" />
    </svg>
</template>

<script setup lang="ts">
import { useId } from 'vue';

type PartiallyOccupiedIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<PartiallyOccupiedIconProps>();
const maskId = useId();
</script>
